// LIST
export const FETCH_BLOGS = "app/Blogs/FETCH_BLOGS";
export const FETCH_BLOGS_SUCCESS = "app/Blogs/FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "app/Blogs/FETCH_BLOGS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Blogs/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Blogs/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Blogs/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_BLOGS = "app/Blogs/ADD_BLOGS";
export const ADD_BLOGS_SUCCESS = "app/Blogs/ADD_BLOGS_SUCCESS";
export const ADD_BLOGS_FAILURE = "app/Blogs/ADD_BLOGS_FAILURE";
// EDIT
export const EDIT_BLOGS = "app/Blogs/EDIT_BLOGS";
export const EDIT_BLOGS_SUCCESS = "app/Blogs/EDIT_BLOGS_SUCCESS";
export const EDIT_BLOGS_FAILURE = "app/Blogs/EDIT_BLOGS_FAILURE";
// DELETE
export const DELETE_BLOGS = "app/Blogs/DELETE_BLOGS";
export const DELETE_BLOGS_SUCCESS = "app/Blogs/DELETE_BLOGS_SUCCESS";
export const DELETE_BLOGS_FAILURE = "app/Blogs/DELETE_BLOGS_FAILURE";
